import React from 'react';
import Loading from './Loading';

// Custom error class for timeouts
class TimeoutError extends Error {
    constructor(message = 'Loading timeout') {
        super(message);
        this.name = 'TimeoutError';
    }
}

class LoadableErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, isTimeout: false };
    }

    static getDerivedStateFromError(error) {
        const isTimeout = !!error && (error.name === 'TimeoutError' || error instanceof TimeoutError);
        return { hasError: true, isTimeout };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Loadable component error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            const retry = () => {
                this.setState({ hasError: false, isTimeout: false });
                window.location.reload();
            };

            return <Loading error={!this.state.isTimeout} timedOut={this.state.isTimeout} retry={retry} />;
        }

        return this.props.children;
    }
}

export { LoadableErrorBoundary, TimeoutError };
